import i18n from "@/libs/i18n/i18n"


export default () => ({
  
    patients:[],
    genders: [
        { value: "female", text: i18n.t("general.female") },
        { value: "male", text: i18n.t("general.male") },
      ],
      addressTypes: [
        { value: "home", text: i18n.t("address.home") },
        { value: "work", text: i18n.t("address.work") },
      ],
      maritalStatuses: [
        { value: "married", text: i18n.t("user.married") },
        { value: "single", text: i18n.t("user.single") },
      ],
      roles: [],
      users: [],
      role: "",
      firstName: "",
      lastName: "",
      mobile: "",
      mobileCountryId: "",
      fatherName: "",
      nationalCode: "",
      otherCode: "",
      dateOfBirth: "",
      mobiles: [{ mobile: "", countryId: "" }],
      email: "",
      country: "",
      province: "",
      city: "",
      gender: "",
      issuedCity: "",
      birthCity: "",
      issuedProvince: "",
      birthProvince: "",
      maritalStatus: "",
      referralWays: "",
      referralWay: "",
      referrerName: "",
      referrerUser: "",
      referrerUsers: [],
      referrerAddress: "",
      referrerNationalCode: "",
      spouses: [
        {
          relationshipId: {
            _id: null,
            dateOfMarriage: "",
          },
          spouseId: {
            relationshipId: null,
            spouseId: null,
            countryId: "",
            firstName: "",
            lastName: "",
            fatherName: "",
            nationalCode: "",
            identityCode:"",
            dateOfBirth: "",
          },
        },
      ],
      phones: [{ phone: "", internal: "", type: "", countryId:"" }],
      // issuedCountry: '',
      addresses: [
        {
          provinceId: "",
          cityId: "",
          address: "",
          postalCode: "",
          type: "",
          countryId: "",
        },
      ],
      patientToEdit: null,
      total: ""
    
 
    })
